// @ts-nocheck
/**
 * ドラフトシステム - スタイル定義
 */

export const draftStyles = {
  // ========================================
  // 共通
  // ========================================
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f0f23 100%)',
    color: '#fff',
    fontFamily: "'Noto Sans JP', sans-serif",
  },

  // ========================================
  // ロビー
  // ========================================
  lobbyContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '40px 20px',
    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f0f23 100%)',
  },

  lobbyHeader: {
    textAlign: 'center',
    marginBottom: '40px',
  },

  lobbyTitle: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    background: 'linear-gradient(135deg, #ffd700 0%, #ff8c00 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    marginBottom: '10px',
  },

  lobbySubtitle: {
    fontSize: '1rem',
    color: '#aaa',
  },

  lobbyContent: {
    maxWidth: '600px',
    width: '100%',
  },

  sectionTitle: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    color: '#ffd700',
    marginBottom: '15px',
    borderBottom: '1px solid #444',
    paddingBottom: '8px',
  },

  // ルール説明
  rulesSection: {
    background: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '20px',
  },

  rulesList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    color: '#ccc',
    lineHeight: '1.8',
  },

  rulesListItem: {
    marginBottom: '8px',
    paddingLeft: '20px',
    position: 'relative',
  },

  // 参加人数選択
  playerCountSection: {
    background: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '20px',
  },

  playerCountButtons: {
    display: 'flex',
    gap: '10px',
    marginBottom: '15px',
  },

  playerCountButton: {
    flex: 1,
    padding: '15px',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: '#444',
    borderRadius: '8px',
    background: 'transparent',
    color: '#fff',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },

  playerCountButtonActive: {
    borderColor: '#ffd700',
    background: 'rgba(255, 215, 0, 0.2)',
    color: '#ffd700',
  },

  playerCountInfo: {
    fontSize: '0.9rem',
    color: '#aaa',
    textAlign: 'center',
  },

  // 保存セッション
  savedSessionSection: {
    background: 'rgba(100, 200, 100, 0.1)',
    border: '1px solid rgba(100, 200, 100, 0.3)',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '20px',
  },

  savedSessionInfo: {
    fontSize: '0.95rem',
    lineHeight: '1.8',
    color: '#ccc',
  },

  savedSessionDate: {
    fontSize: '0.85rem',
    color: '#888',
    marginTop: '10px',
  },

  // アクションボタン
  actionButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginTop: '30px',
  },

  startButton: {
    padding: '18px 30px',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    background: 'linear-gradient(135deg, #ffd700 0%, #ff8c00 100%)',
    color: '#000',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },

  resumeButton: {
    padding: '18px 30px',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    border: '2px solid #64c864',
    borderRadius: '8px',
    background: 'rgba(100, 200, 100, 0.2)',
    color: '#64c864',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },

  backButton: {
    padding: '15px 30px',
    fontSize: '1rem',
    border: '1px solid #666',
    borderRadius: '8px',
    background: 'transparent',
    color: '#aaa',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },

  discardButton: {
    padding: '15px 30px',
    fontSize: '1rem',
    border: '2px solid #ff6b6b',
    borderRadius: '8px',
    background: 'rgba(255, 107, 107, 0.2)',
    color: '#ff6b6b',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },

  cancelButton: {
    padding: '15px 30px',
    fontSize: '1rem',
    border: '1px solid #666',
    borderRadius: '8px',
    background: 'transparent',
    color: '#aaa',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },

  // ========================================
  // モーダル
  // ========================================
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },

  modalContent: {
    background: '#1a1a2e',
    borderRadius: '16px',
    padding: '30px',
    maxWidth: '400px',
    width: '90%',
    border: '1px solid #333',
  },

  modalTitle: {
    fontSize: '1.3rem',
    fontWeight: 'bold',
    color: '#ffd700',
    marginBottom: '15px',
    textAlign: 'center',
  },

  modalText: {
    fontSize: '0.95rem',
    color: '#ccc',
    lineHeight: '1.6',
    textAlign: 'center',
    marginBottom: '25px',
  },

  modalButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },

  // ========================================
  // ピック画面
  // ========================================
  pickContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f0f23 100%)',
  },

  pickHeader: {
    padding: '15px 20px',
    background: 'rgba(0, 0, 0, 0.3)',
    borderBottom: '1px solid #333',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  roundInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },

  roundText: {
    fontSize: '1.1rem',
    color: '#fff',
  },

  timerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  timerIcon: {
    fontSize: '1.2rem',
  },

  timerText: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    minWidth: '40px',
  },

  timerWarning: {
    color: '#ff6b6b',
  },

  timerNormal: {
    color: '#64c864',
  },

  progressInfo: {
    fontSize: '0.9rem',
    color: '#aaa',
  },

  // パック表示エリア
  packArea: {
    flex: 1,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
  },

  packTitle: {
    fontSize: '1rem',
    color: '#ffd700',
    marginBottom: '15px',
    textAlign: 'center',
  },

  packGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
    gap: '15px',
    justifyContent: 'center',
    maxWidth: '900px',
    margin: '0 auto',
  },

  // カード
  packCard: {
    background: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '8px',
    padding: '10px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: '2px solid transparent',
  },

  packCardSelected: {
    borderColor: '#ffd700',
    background: 'rgba(255, 215, 0, 0.15)',
    transform: 'scale(1.02)',
  },

  packCardHover: {
    background: 'rgba(255, 255, 255, 0.1)',
  },

  cardName: {
    fontSize: '0.9rem',
    fontWeight: 'bold',
    color: '#fff',
    marginBottom: '5px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  cardInfo: {
    fontSize: '0.8rem',
    color: '#aaa',
  },

  cardRarity: {
    display: 'inline-block',
    padding: '2px 6px',
    borderRadius: '4px',
    fontSize: '0.75rem',
    fontWeight: 'bold',
    marginRight: '5px',
  },

  // レアリティカラー
  rarityC: { background: '#666', color: '#fff' },
  rarityUC: { background: '#3d7a3d', color: '#fff' },
  rarityR: { background: '#4a7ab7', color: '#fff' },
  raritySR: { background: '#9d4ce6', color: '#fff' },
  rarityUR: { background: '#ff8c00', color: '#fff' },
  rarityHR: { background: 'linear-gradient(135deg, #ffd700, #ff8c00)', color: '#000' },
  raritySEC: { background: 'linear-gradient(135deg, #ff69b4, #ff1493)', color: '#fff' },

  // アクションエリア
  pickActionArea: {
    padding: '20px',
    background: 'rgba(0, 0, 0, 0.3)',
    borderTop: '1px solid #333',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  selectedCardInfo: {
    flex: 1,
  },

  selectedCardName: {
    fontSize: '1.1rem',
    fontWeight: 'bold',
    color: '#ffd700',
  },

  selectedCardDetails: {
    fontSize: '0.9rem',
    color: '#aaa',
  },

  pickButton: {
    padding: '15px 40px',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    background: 'linear-gradient(135deg, #ffd700 0%, #ff8c00 100%)',
    color: '#000',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },

  pickButtonDisabled: {
    background: '#444',
    color: '#666',
    cursor: 'not-allowed',
  },

  // ========================================
  // デッキ構築画面
  // ========================================
  deckBuilderContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f0f23 100%)',
  },

  deckBuilderHeader: {
    padding: '15px 20px',
    background: 'rgba(0, 0, 0, 0.3)',
    borderBottom: '1px solid #333',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  deckBuilderTitle: {
    fontSize: '1.3rem',
    fontWeight: 'bold',
    color: '#ffd700',
  },

  deckBuilderMain: {
    flex: 1,
    display: 'flex',
    gap: '20px',
    padding: '20px',
    overflow: 'hidden',
  },

  // サイドボード
  sideboardSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    background: 'rgba(255, 255, 255, 0.03)',
    borderRadius: '12px',
    padding: '15px',
    overflow: 'hidden',
  },

  sideboardTitle: {
    fontSize: '1rem',
    fontWeight: 'bold',
    color: '#aaa',
    marginBottom: '10px',
    display: 'flex',
    justifyContent: 'space-between',
  },

  sideboardGrid: {
    flex: 1,
    overflowY: 'auto',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
    gap: '10px',
    alignContent: 'start',
  },

  // デッキ
  deckSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    background: 'rgba(255, 215, 0, 0.05)',
    borderRadius: '12px',
    padding: '15px',
    border: '1px solid rgba(255, 215, 0, 0.2)',
    overflow: 'hidden',
  },

  deckTitle: {
    fontSize: '1rem',
    fontWeight: 'bold',
    color: '#ffd700',
    marginBottom: '10px',
    display: 'flex',
    justifyContent: 'space-between',
  },

  deckGrid: {
    flex: 1,
    overflowY: 'auto',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
    gap: '10px',
    alignContent: 'start',
  },

  // 統計
  statsSection: {
    width: '200px',
    background: 'rgba(255, 255, 255, 0.03)',
    borderRadius: '12px',
    padding: '15px',
  },

  statsTitle: {
    fontSize: '1rem',
    fontWeight: 'bold',
    color: '#fff',
    marginBottom: '15px',
    borderBottom: '1px solid #333',
    paddingBottom: '8px',
  },

  statItem: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '8px',
    fontSize: '0.9rem',
  },

  statLabel: {
    color: '#aaa',
  },

  statValue: {
    color: '#fff',
    fontWeight: 'bold',
  },

  // コスト曲線
  costCurveContainer: {
    marginTop: '20px',
  },

  costCurveTitle: {
    fontSize: '0.9rem',
    color: '#aaa',
    marginBottom: '10px',
  },

  costCurveBar: {
    display: 'flex',
    alignItems: 'flex-end',
    height: '60px',
    gap: '4px',
  },

  costCurveBarItem: {
    flex: 1,
    background: '#ffd700',
    borderRadius: '2px 2px 0 0',
    minHeight: '4px',
    transition: 'height 0.3s ease',
  },

  costCurveLabels: {
    display: 'flex',
    gap: '4px',
    marginTop: '5px',
  },

  costCurveLabel: {
    flex: 1,
    fontSize: '0.7rem',
    color: '#666',
    textAlign: 'center',
  },

  // バリデーション
  validationSection: {
    marginTop: '20px',
    padding: '10px',
    borderRadius: '8px',
  },

  validationValid: {
    background: 'rgba(100, 200, 100, 0.1)',
    border: '1px solid rgba(100, 200, 100, 0.3)',
  },

  validationInvalid: {
    background: 'rgba(255, 107, 107, 0.1)',
    border: '1px solid rgba(255, 107, 107, 0.3)',
  },

  validationTitle: {
    fontSize: '0.9rem',
    fontWeight: 'bold',
    marginBottom: '8px',
  },

  validationMessage: {
    fontSize: '0.8rem',
    lineHeight: '1.5',
  },

  // アクションエリア
  deckBuilderActions: {
    padding: '15px 20px',
    background: 'rgba(0, 0, 0, 0.3)',
    borderTop: '1px solid #333',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  autoButton: {
    padding: '12px 25px',
    fontSize: '1rem',
    border: '1px solid #666',
    borderRadius: '8px',
    background: 'transparent',
    color: '#aaa',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },

  confirmButton: {
    padding: '15px 40px',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    background: 'linear-gradient(135deg, #ffd700 0%, #ff8c00 100%)',
    color: '#000',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },

  confirmButtonDisabled: {
    background: '#444',
    color: '#666',
    cursor: 'not-allowed',
  },

  // ========================================
  // ピック済みリスト
  // ========================================
  picksSection: {
    background: 'rgba(255, 255, 255, 0.03)',
    borderRadius: '12px',
    padding: '15px',
    marginTop: '20px',
  },

  picksTitle: {
    fontSize: '1rem',
    fontWeight: 'bold',
    color: '#aaa',
    marginBottom: '10px',
  },

  picksList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },

  picksItem: {
    fontSize: '0.8rem',
    padding: '4px 8px',
    background: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '4px',
    color: '#ccc',
  },

  // ========================================
  // 結果画面
  // ========================================
  resultContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f0f23 100%)',
  },

  resultTitle: {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: '#ffd700',
    marginBottom: '20px',
  },

  resultRank: {
    fontSize: '4rem',
    fontWeight: 'bold',
    background: 'linear-gradient(135deg, #ffd700 0%, #ff8c00 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    marginBottom: '30px',
  },

  resultStats: {
    background: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '12px',
    padding: '20px 40px',
    marginBottom: '30px',
  },

  resultStatItem: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '40px',
    marginBottom: '10px',
    fontSize: '1.1rem',
  },
};

// レアリティスタイルを取得
export const getRarityStyle = (rarity) => {
  const styles = {
    C: draftStyles.rarityC,
    UC: draftStyles.rarityUC,
    R: draftStyles.rarityR,
    SR: draftStyles.raritySR,
    UR: draftStyles.rarityUR,
    HR: draftStyles.rarityHR,
    SEC: draftStyles.raritySEC,
    ALT: draftStyles.raritySEC,
    SP: draftStyles.raritySEC,
    GR: draftStyles.rarityHR,
  };
  return styles[rarity] || draftStyles.rarityC;
};

export default draftStyles;
